import { render, staticRenderFns } from "./PortfolioContact.vue?vue&type=template&id=0675d5dd&"
import script from "./PortfolioContact.vue?vue&type=script&lang=js&"
export * from "./PortfolioContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports